// extracted by mini-css-extract-plugin
export default {"mall_orders":"MallOrder_mall_orders__Fj4j8","default":"MallOrder_default__duQs+","describe":"MallOrder_describe__RVfkt","jump_other":"MallOrder_jump_other__9d7kj"};